import React from 'react';
import { LegalDoc } from '../components/LegalDoc';
import { TERMS, TERMS_UPDATED } from '../data/terms';
export function Terms() {
  return <LegalDoc title="Terms of Service" updated={TERMS_UPDATED} sections={TERMS} data-id="element-674" data-mp="3tpk37dfthx2u" />;
}